/**
 * External Account Type
 */
export enum ExternalAccountType {
  /**
   * Voximplant.
   * https://voximplant.com
   */
  Call = 'call',

  /**
   * Hope Care
   * https://partner-p3-n1.pt/en/
   */
  PartnerP3N1 = 'partner-p3-n1',

  /**
   * Altice SmartAL
   * https://www.altice-empresas.pt/solucoes/iot/saude-bem-estar/smartal
   */
  PartnerP3N2 = 'partner-p3-n2',

  /**
   * DeepClick
   * https://www.deepclick.com
   */
  PartnerP3N3 = 'partner-p3-n3',

  /**
   * Itelcare (Kerox)
   * https://www.itelcare.es/
   */
  PartnerP3N4 = 'partner-p3-n4',
}
